import React, {useState} from 'react'

import './_accordion.scss'

import cn from '../../../../commons/src/libs/class-names'
import {mapChildrenWithFragments} from '../../../../commons/src/services/react-children'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import AccordionItem from './AccordionItem'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
  }
>

const Accordion = ({className, children, ...props}: Props) => {
  const [isOpen, setIsOpen] = useState(
    mapChildrenWithFragments<React.ComponentProps<typeof AccordionItem>, boolean>(
      children,
      item => !!item.props.isOpen
    )
  )

  return (
    <div {...props} className={cn('Accordion', {}, className)}>
      {mapChildrenWithFragments<React.ComponentProps<typeof AccordionItem>>(
        children,
        (item, index) =>
          React.cloneElement(item, {
            isOpen: !!isOpen[index],
            onChange: (value: boolean) => {
              const nextIsOpen = []
              nextIsOpen[index] = value
              setIsOpen(nextIsOpen)
            },
          })
      )}
    </div>
  )
}

export default Accordion
